import { useContext } from "react";

import { FeatureContext } from "../feature-context";

export const useFeature = featureName => {
    const { features } = useContext(FeatureContext);

    return features && features[featureName] ? features[featureName] : false;
};
